import styled, { css } from 'styled-components';

interface WaveProps {
    $wave: 'default' | 'xflipped' | 'yflipped';
}

export const Wrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        min-height: 5rem;
        overflow: hidden;
        background-color: var(--bg-color, ${theme.colors.primary.hex});
        margin-top: var(--margin-top, 1.5rem);
        margin-bottom: var(--margin-bottom, 1.5rem);
    `}
`;

const backgroundStyles = ($wave, theme) => css`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    opacity: 0.25;

    ${$wave === 'xflipped'
        ? css`
              transform: translateX(-20%) scale(-2, 2);
          `
        : $wave === 'yflipped'
        ? css`
              transform: translateX(-20%) scale(2, -2);
          `
        : css`
              transform: translateX(-20%) scale(2);
          `}

    @media ${theme.breakpoints.medium.media} {
        top: -1rem;
        ${$wave === 'xflipped'
            ? css`
                  transform: translateX(-31%) scale(-1, 1);
              `
            : $wave === 'yflipped'
            ? css`
                  transform: translateX(-31%) scale(1, -1);
              `
            : css`
                  transform: translateX(-31%) scale(1);
              `}
    }

    @media ${theme.breakpoints.large.media} {
        ${$wave === 'xflipped'
            ? css`
                  transform: translateX(0) scale(-1, 1);
              `
            : $wave === 'yflipped'
            ? css`
                  transform: translateX(0) scale(1, -1);
              `
            : css`
                  transform: translateX(0) scale(1);
              `}
    }
`;

export const Background = styled.div<WaveProps>`
    ${({ $wave, theme }) => css`
        ${backgroundStyles($wave, theme)}

        width: 300%;
        top: -4rem;

        @media ${theme.breakpoints.medium.media} {
            top: -1rem;
            width: 200%;
        }

        @media ${theme.breakpoints.large.media} {
            width: 100%;
        }
    `}
`;
